var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.046 3.486a.75.75 0 0 1-.032 1.06l-7.93 7.474a.85.85 0 0 1-1.188-.022l-2.68-2.72a.75.75 0 1 1 1.068-1.053l2.234 2.267 7.468-7.038a.75.75 0 0 1 1.06.032Z"
  })));
};

export { SvgCheckmark as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xNC4wNDU4IDMuNDg1NkMxNC4zMjk5IDMuNzg3MDMgMTQuMzE1OCA0LjI2MTY5IDE0LjAxNDQgNC41NDU3OUw2LjA4NDU2IDEyLjAxOTdDNS43NDgyOSAxMi4zMzY2IDUuMjIwNDIgMTIuMzI2OSA0Ljg5NjA5IDExLjk5NzdMMi4yMTU3NiA5LjI3NzM3QzEuOTI1MDQgOC45ODIzMSAxLjkyODU2IDguNTA3NDUgMi4yMjM2MSA4LjIxNjc0QzIuNTE4NjcgNy45MjYwMiAyLjk5MzUzIDcuOTI5NTQgMy4yODQyNCA4LjIyNDU5TDUuNTE4MzkgMTAuNDkyMUwxMi45ODU2IDMuNDU0MjFDMTMuMjg3IDMuMTcwMTEgMTMuNzYxNyAzLjE4NDE2IDE0LjA0NTggMy40ODU2WiIvPgo8L3N2Zz4K";